var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill:none;\n        stroke:#000;\n        stroke-miterlimit:10;\n      }\n    ")),React.createElement("path",{"className":"cls-1","d":"M17.22,43.49.63,21.9,17.23.3","key":1})]);
}

ArrowLeft.defaultProps = {"id":"arrow-left","data-name":"arrow left","viewBox":"0 0 17.62 43.8"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
